// extracted by mini-css-extract-plugin
export default {"wrapper":"loginPasswordInput_wrapper__ZJG+S","svg":"loginPasswordInput_svg__hhyKc"};